import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-play\">\r\n<path d=\"M27.5695 15.6423C28.2172 16.0307 28.2172 16.9693 27.5695 17.3577L11.0142 27.2835C10.3477 27.6831 9.5 27.203 9.5 26.4258L9.5 6.57418C9.5 5.79703 10.3477 5.31689 11.0142 5.71651L27.5695 15.6423Z\" fill=\"#1CA59D\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol